import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import zhCN from "./zh-CN.json";
import fr from "./fr.json";

const LOCALE_KEY = "school_ui_locale";

function detectInitialLocale(): string {
  const stored = localStorage.getItem(LOCALE_KEY);
  if (stored) return stored;
  const navLang = typeof navigator !== "undefined" ? navigator.language : "en";
  if (navLang.toLowerCase().startsWith("zh")) return "zh-CN";
  return "en";
}

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    "zh-CN": { translation: zhCN },
    fr: { translation: fr },
  },
  lng: detectInitialLocale(),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

// <html lang> 跟随当前语言,避免浏览器因声明语言与内容不符触发整页
// 机翻(kch preschool 2026-08-05 事故的同类风险;index.html 另有
// notranslate 兜底)。
function syncHtmlLang(lng: string) {
  document.documentElement.lang = lng;
}
syncHtmlLang(i18n.language);
i18n.on("languageChanged", syncHtmlLang);

export function setLocale(locale: string): void {
  localStorage.setItem(LOCALE_KEY, locale);
  void i18n.changeLanguage(locale);
}

export default i18n;
